import React, { useState } from "react";
import { Container, Button, Form, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Tenant from "./sections/Tenant";
import Regions from "./sections/Regions";
import SubRegions from "./sections/SubRegions";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { CREATE_TENANT_MUTATION } from "../../../graphql/mutations";

const AddTenantPage = ({ subscriptions, env, handleEnvChange }) => {
  const navigate = useNavigate();
  const [createTenant, { loading: mutationLoading }] = useMutation(CREATE_TENANT_MUTATION);
  const [regions, setRegions] = useState([{ id: 1, name: "" }]);
  const [subregions, setSubregions] = useState([{ id: 1, name: "" }]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await createTenant({
        variables: {
          alias: e.target.tenantName.value,
          subscriptionId: e.target.subscriptionId.value,
          regions: regions.map((region) => region.name),
          subRegions: subregions.map((subregion) => subregion.name),
          description: e.target.description.value,
          defaultUnit: e.target.defaultUnit.value
        }
      });
      if (data) {
        toast.success(`Database Tenant created successfully with ID: ${data?.createTenant}`);
        handleEnvChange(env, data.createTenant, e.target.tenantName.value);
      } else {
        toast.error("Error creating tenant");
      }
    } catch {
      setTimeout(() => {
        toast.error("Failed to edit tenant.");
      }, 200);
    } finally {
      navigate("/tenants");
    }
  };

  return (
    <Container className="mt-1">
      <h4 className="mb-4">Add New Tenant</h4>
      <Card className="border mb-3" style={{ maxHeight: "600px", overflowY: "scroll" }}>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Tenant subscriptions={subscriptions} />
            <Regions regions={regions} onSetRegions={setRegions} />
            <SubRegions subregions={subregions} onSetSubregions={setSubregions} />
            <div className="d-grid">
              <Button variant="primary" type="submit" className="mt-1 mb-3 mx-auto" style={{ width: "25%" }} disabled={mutationLoading}>
                {mutationLoading ? "Creating tenant..." : "Create Tenant"}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AddTenantPage;
